export const SERVER_URL = import.meta.env.VITE_SERVER_URL || 'https://api.airi.build'
